import {
  ApplicationId,
  clientIdentification
} from '@gjensidige/service-client-identification';

export function isCommercialContext() {
  const applicationId = clientIdentification.getApplicationId();
  return (
    applicationId === ApplicationId.Narnet ||
    applicationId === ApplicationId.NarnetM
  );
}
